<template>
    <div class="main-body-instructions" v-if="instructions.length>0">
        <!-- 上半部分 -->
        <div class="main-body-instructions-top">
            <!-- 右侧 -->
            <el-button
                type='text'
                size='small'
                class="main-body-instructions-more"
                @click="$router.push('/instructions')">
                <span>{{$t("message.main.more")}}</span>
                <i class="el-icon-arrow-right el-icon--right"></i>
            </el-button>
            <!-- 左侧标题 -->
            <div class="main-body-instructions-title">{{$t("message.main.instructions")}}</div>
        </div>
        <!-- 下半部分 -->
        <el-row :gutter="15">
            <el-col :span="6"
                v-for="(item,index) in instructions"
                :key="index">
                <el-card shadow="hover" :body-style="{ padding: 0 }">
                    <!-- 图片容器 -->
                    <router-link :to="{name: 'instrdetail', query:{id: item.id}}" class="instructions-imgs-box">
                        <img :src="item.image" alt="">
                    </router-link>
                    <!-- 文字容器 -->
                    <div class="instructions-words-box">
                        <router-link :to="{name: 'instrdetail', query:{id: item.id}}" class="instructions-title">
                            {{item.title}}
                        </router-link>
                        <p class="instructions-subtitle">{{item.subtitle}}</p>
                    </div>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    data() {
        return {
        }
    },
    computed: mapState({
        instructions: state => state.instructions.mainInstructions
    }),
}
</script>

<style scoped>
/* 组件盒子 */
.main-body-instructions{
    margin-top: 30px;
}

/* 上半部分盒子 */
.main-body-instructions-top{
    margin-bottom: 10px;
}
/* 标题 */
.main-body-instructions-title{
    color: #333;
    font-size: 24px;
}
/* 查看更多按钮 */
.main-body-instructions-more{
    float: right;
}

/* 图片容器 */
.instructions-imgs-box{
    position: relative;
    display: block;
    width: 270px;
    height: 100%;
}
.instructions-imgs-box::before{
    content: "";
    display: block;
    padding-top: 60%;
}
.instructions-imgs-box>img{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 100%;
    max-height: 100%;
}

/* 文字容器 */
.instructions-words-box{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    height: 100px;
    padding: 20px;
}
/* 标题 */
.instructions-words-box>.instructions-title{
    display: block;
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    text-align: center;
    font-size: 14px;
    color: #333;
}
/* 副标题 */
.instructions-words-box>.instructions-subtitle{
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    font-size: 12px;
    font-family: Arial,"宋体";
    color:#b0b0b0;
}
</style>
